import { createStore, useStore } from 'zustand';

import { fetchHistory } from '@lib/api';
import { logger } from '@lib/logger';
import { OrderStateEnum, OrderSummary } from '@lib/types';

import { HistoryStateStore } from './types';
import { fromOrderCompactToOrderSummary } from './fromOrderCompactToOrderSummary';

export const historyStore = createStore<HistoryStateStore>((set) => ({
  orders: [],
  hasMore: false,
  error: null,
  loading: false,
  searchByPhone: '',
  fetch: async (pageNumber: number, phoneNumber?: string) => {
    try {
      set({ loading: true });
      const states = [
        OrderStateEnum.INSPECTING,
        OrderStateEnum.DELIVERED,
        OrderStateEnum.CANCELED,
        OrderStateEnum.REJECTED,
        OrderStateEnum.OUT_FOR_DELIVERY,
        OrderStateEnum.ACCEPTED,
        OrderStateEnum.FOOD_IS_READY,
      ];
      const results = await fetchHistory(pageNumber, states, phoneNumber);
      set({ hasMore: results.haxNext });
      const newOrders = results.items.map(fromOrderCompactToOrderSummary);
      const oldOrders = historyStore.getState().orders;

      set({ orders: (oldOrders as OrderSummary[]).concat(newOrders) });
    } catch (error) {
      logger.error(error);
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
  searchForOrders: async (pageNumber: number, phoneNumber: string) => {
    await set({ orders: [], searchByPhone: phoneNumber });
    await historyStore.getState().fetch(pageNumber, phoneNumber);
  },
  reset: () => {
    set({
      orders: [],
      hasMore: false,
      error: null,
      loading: false,
    });
  },
}));

export const useHistoryStore = () => useStore(historyStore);
export const useHistoryOrder = (id: string) => {
  const { orders } = useHistoryStore();
  return { order: orders.find((o) => o.uuid === id) } as const;
};
